 /* Cirkle Edits: change this varable $ to $_ */   
  const $_ = elem => document.querySelector(elem);
 /* Cirkle Edits: change this varable $ to $_ */    
const countdown = function(_config) {
  const tarDate = $_(_config.target).getAttribute('data-date').split('-');
  const day = parseInt(tarDate[0]);
  const month = parseInt(tarDate[1]);
  const year = parseInt(tarDate[2]);
  let tarTime = $_(_config.target).getAttribute('data-time');
  let tarhour, tarmin;

  if (tarTime != null) {
    tarTime = tarTime.split(':');
    tarhour = parseInt(tarTime[0]);
    tarmin = parseInt(tarTime[1]);
  }

  let months = [31, new Date().getFullYear() % 4 == 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  let dateNow = new Date();
  let dayNow = dateNow.getDate();
  let monthNow = dateNow.getMonth() + 1;
  let yearNow = dateNow.getFullYear();
  let hourNow = dateNow.getHours();
  let minNow = dateNow.getMinutes();
  let count_day = 0, count_hour = 0, count_min = 0;
  let count_day_isSet = false;
  let isOver = false;

  // Set the date we're counting down to
  //const countDownDate = new Date(year, month-1, day, tarhour, tarmin, 0, 0).getTime();

// Définir la date spécifique (20/11/2023 à 8h)
const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);

const countDownDate = new Date(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate(), 0, tarmin, 0, 0).getTime();


  
  $_(_config.target+' .day .word').innerHTML = _config.dayWord;
  $_(_config.target+' .hour .word').innerHTML = _config.hourWord;
  $_(_config.target+' .min .word').innerHTML = _config.minWord;
  $_(_config.target+' .sec .word').innerHTML = _config.secWord; 

  const updateTime = () => {
    // Get todays date and time
    const now = new Date().getTime();

    // Find the distance between now an the count down date
    const distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    requestAnimationFrame(updateTime);

    $_(_config.target+' .day .num').innerHTML = addZero(days);
    $_(_config.target+' .hour .num').innerHTML = addZero(hours);
    $_(_config.target+' .min .num').innerHTML = addZero(minutes);
    $_(_config.target+' .sec .num').innerHTML = addZero(seconds);

    // If the count down is over, write some text
    if (distance < 0) {
      $(".countdown").innerHTML = "EXPIRED";
    }
  }

  updateTime();
}

const addZero = (x) => (x < 10 && x >= 0) ? "0"+x : x;



  class Stickycountdown extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.countdown = document.getElementById('shopify-section-countdown-bar');
      this.countdownBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hidecountdownOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventcountdownReveal', this.hidecountdownOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventcountdownReveal', this.hidecountdownOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.countdownBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.countdown);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.countdownBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.countdownBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.countdownBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.countdown.classList.add('shopify-section-countdown-hidden', 'shopify-section-countdown-sticky');
      this.countdown.classList.add( 'shopify-section-countdown-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.countdown.classList.add('shopify-section-countdown-sticky', 'animate');
      this.countdown.classList.remove('shopify-section-countdown-hidden');
    }

    reset() {
      this.countdown.classList.remove('shopify-section-countdown-hidden', 'shopify-section-countdown-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.countdown.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.countdown.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-countdown', Stickycountdown);